import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NewsletterUnsubscribePage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  const handleUnsubscribe = async () => {
    if (!token) {
      setStatus('error');
      setMessage('Ungültiger Abmeldelink.');
      return;
    }

    setStatus('loading');

    try {
      const response = await axios.post(`${BACKEND_URL}/api/newsletter/unsubscribe`, { token });
      setStatus('success');
      setMessage(response.data.message);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.detail || 'Abmeldung fehlgeschlagen.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0B0F14' }}>
      <div className="max-w-md w-full mx-4">
        <div className="bg-[#1A1F26] rounded-xl p-8 border border-white/10">
          {status === 'idle' && (
            <>
              <h1 className="text-2xl font-bold text-white mb-4">Newsletter abmelden</h1>
              <p className="text-gray-400 mb-6">
                Möchten Sie sich wirklich vom Newsletter abmelden?
              </p>
              <div className="flex gap-3">
                <Button
                  onClick={handleUnsubscribe}
                  variant="outline"
                  className="flex-1 border-red-500/50 text-red-400 hover:bg-red-500/10"
                >
                  Ja, abmelden
                </Button>
                <Link to="/" className="flex-1">
                  <Button className="w-full bg-gradient-to-r from-blue-500 to-cyan-400">
                    Abbrechen
                  </Button>
                </Link>
              </div>
            </>
          )}

          {status === 'loading' && (
            <div className="text-center">
              <div className="w-8 h-8 mx-auto mb-4 border-2 border-blue-400 border-t-transparent rounded-full animate-spin"></div>
              <p className="text-gray-400">Wird abgemeldet...</p>
            </div>
          )}

          {status === 'success' && (
            <>
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-500/20 flex items-center justify-center">
                <CheckCircle className="w-10 h-10 text-green-400" />
              </div>
              <h1 className="text-2xl font-bold text-white mb-2 text-center">Erfolgreich abgemeldet</h1>
              <p className="text-gray-400 mb-6 text-center">{message}</p>
              <Link to="/">
                <Button className="w-full bg-gradient-to-r from-blue-500 to-cyan-400">
                  Zur Startseite
                </Button>
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-500/20 flex items-center justify-center">
                <AlertCircle className="w-10 h-10 text-red-400" />
              </div>
              <h1 className="text-2xl font-bold text-white mb-2 text-center">Fehler</h1>
              <p className="text-gray-400 mb-6 text-center">{message}</p>
              <Link to="/">
                <Button className="w-full" variant="outline">
                  Zur Startseite
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsletterUnsubscribePage;
